
<template>
    <hm-content>
        <div class="table-panel flex top">
            <p>企业发布记录是记录企微管理员或负责人编辑内容，选择可见客户，通知成员发布，成员确认后内容即可发布到客户的朋友圈</p>
        </div>
        <div class="table-panel flex" style="margin-top: 30px">
            <a href="https://work.weixin.qq.com/wework_admin/loginpage_wx?redirect_uri=https%3A%2F%2Fwork.weixin.qq.com%2Fwework_admin%2Fframe#customer/moments/list">
                <el-button type="primary" size="small" >
                    发布企业朋友圈
                </el-button>
            </a>
            <p style="float:left; margin-left: 20px; line-height: 36px;">每位客户的朋友圈每个月最多展示4条企业发表的内容</p>
        </div>

        <div class="table-panel flex title ">
            <p>1.在企业微信中发布朋友圈</p>
        </div>
        <div class="table-panel flex img">
            <img src="https://axure-file.lanhuapp.com/6b40b68e-dfd6-41e2-b7c3-e3df866a4de2__9889997ab831a5bd7ded4373c28239f1.png">
        </div>
        <div class="table-panel flex title ">
            <p>2.在员工朋友圈查看从企微朋友圈同步过来的朋友圈内容</p>
        </div>
        <div class="table-panel flex img">
            <img src="https://imgcdn.hemiao100.com/qiwei-moment_2-2.e538dde54f58.png">
        </div>
    </hm-content>
</template>

<script>

    export default {
        data() {
            return {
            };
        },
    };
</script>
<style lang="scss" scoped>
    .top{
        width: 1000px;
        height:36px;
        border: 1px solid #E50065;
        background: #FEDEEC;
    }
    .top>p{
        line-height: 36px;
        font-size: 14px;
        margin-left: 3px;
        color: #E50065;
    }
    .title{
        width: 750px;
        padding: 0;
        height:36px;
        line-height: 36px;
        margin-top: 30px;
        background: #eeeeee;
    }


    .img{
        width: 1500px;
        height: 517px;
    }
</style>
